import React, { useState } from "react";
import BonkBark from "../../../assets/newsletter/JOINBONKBARK.svg";

export const NewsLetterSubscription: React.FC = () => {
	const [email, setEmail] = useState("");

	const handleSubscribe = (e: React.FormEvent<HTMLFormElement>) => {
		// clear input after submission
		setTimeout(() => setEmail(""), 0);
	};

	return (
		<div className="newsletter-subscription">
			<img
				src={BonkBark}
				alt="Join Bonk Bark"
				className="newsletter-bonk-bark"
			/>
			<p>Subscribe to the BONK newsletter to receive the latest news. No spam, we promise.</p>
			<form
				action="https://bonkcoin.us12.list-manage.com/subscribe/post?u=116707103b8f7fa438896f97f&amp;id=d607884fc3&amp;f_id=0099e4e0f0"
				method="post"
				id="mc-embedded-subscribe-form"
				name="mc-embedded-subscribe-form"
				className="validate subscription-form"
				target="_blank"
				noValidate
				onSubmit={handleSubscribe}
			>
				<input
					type="email"
					name="EMAIL"
					className="required email"
					placeholder="Enter your email"
					required
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				{/* Mailchimp honeypot */}
				<div
					style={{ position: "absolute", left: "-5000px" }}
					aria-hidden="true"
				>
					<input
						type="text"
						name="b_116707103b8f7fa438896f97f_d607884fc3"
						tabIndex={-1}
						defaultValue=""
					/>
				</div>
				<button
					type="submit"
					className="subscribe-button"
				>
					<span className="subscribe-button-text">Subscribe</span>
				</button>
			</form>
		</div>
	);
};
